import React from 'react'
import DailySalesReport from '../Components/Reports/DailySalesReport'

function DailySalesReportPage() {
  return (
    <>
        <DailySalesReport/>
    </>
  )
}

export default DailySalesReportPage
